<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview ref='neTreeForNoRealTaskCreate' id='neTreeForNoRealTaskCreate' :fields='fields' :nodeSelected="nodeSelectedOfNoRealTaskResourceTree"></ejs-treeview>
    </div>
  </div>
</template>

<script>

import CommonUtil from "../../../../util/CommonUtil";

export default {
  name: 'NeTreeForNoRealTaskCreate',
  props: [
    'addOrModifyTaskFlag',
    'neIdsUnderTaskByTaskId'
  ],
  data() {
    return {
      fields: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        iconCss: 'iconCls'
      },
    };
  },
  methods: {
    nodeSelectedOfNoRealTaskResourceTree(args) {
      const selectNode = this.$refs.neTreeForNoRealTaskCreate.getTreeData(args.nodeData.id)[0];
      const childrenLength = selectNode.children.length;
      let measureTreeTypeForNoRealTaskCreate = 1;
      if (childrenLength == 0) {
        if(selectNode.attributes.neSwitch == 2){
          measureTreeTypeForNoRealTaskCreate = 3; //任务已经存在
        }else if(selectNode.attributes.neSwitch == 3){
          measureTreeTypeForNoRealTaskCreate = 4; //网元不在线
        }else {
          this.$parent.$refs.MeasureTreeForNoRealTaskCreate.getMeasureObjTreeFoNoRealTaskCreate(selectNode.attributes.neTypeId, selectNode.attributes.neId);
          measureTreeTypeForNoRealTaskCreate = 1;
        }
      }else{
        measureTreeTypeForNoRealTaskCreate = 2; //未选择正确的网元节点
      }
      this.$emit('measureTreeShowTypeChange', measureTreeTypeForNoRealTaskCreate);
    },
    getResourceTreeForNoRealTaskCreate(neTypeCode,cycle) {

      const params = {
        neTypeCode: neTypeCode,
        sampleTime: cycle
      }
      this.$axios.post(`/lte/ems/pm/noReal/task/buildNoRealTaskResourceTreeForCreate.html${CommonUtil.analyticParameter(params)}`).then((response) => {
        this.fields = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    }
  },
  mounted() {
  }
};
</script>

<style>

</style>
